import React from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Button, 
  Box 
} from '@mui/material';
import { Chat as ChatIcon } from '@mui/icons-material';

interface AIChatBlockProps {
  title?: string;
  description?: string;
  buttonText?: string;
  onStartChat?: () => void;
}

const AIChatBlock: React.FC<AIChatBlockProps> = ({
  title = 'Пообщаться с AI-психологом',
  description = 'Наш AI-психолог готов помочь вам прямо сейчас. Он понимает ваши чувства и может предложить эффективные техники.',
  buttonText = 'Начать разговор',
  onStartChat
}) => {
  return (
    <Card sx={{ mb: 4, bgcolor: 'primary.light', color: 'primary.contrastText' }}>
      <CardContent>
        <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ChatIcon />
          {title}
        </Typography>
        <Typography paragraph>
          {description}
        </Typography>
        <Button 
          variant="contained" 
          color="secondary"
          size="large"
          fullWidth
          sx={{ mt: 2 }}
          onClick={onStartChat}
        >
          {buttonText}
        </Button>
      </CardContent>
    </Card>
  );
};

export default AIChatBlock; 